// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3aRsL","buttons":"Footer_buttons__tQRgB"};